import { Link } from "react-router-dom";
import BookButton from "@/components/BookButton";

const CHAPTERS = [
  {
    num: "01",
    label: "The arrival",
    title: "You'll find us before you've decided to stop.",
    body:
      "The gradient-orange W reads from a half-mile out on US-65. By the time you've put the indicator on, you've already noticed that the lot is paved, level, and big enough for whatever you're driving. Front desk lights are on. Inside it smells faintly of coffee — there's a pot brewed twenty minutes ago, and someone is genuinely happy to see you.",
  },
  {
    num: "02",
    label: "The room",
    title: "A quiet that you can hear.",
    body:
      "The room is plain, in the best way. Crisp sheets, a firm bed, blackout curtains that mean it, and a renovated bathroom with an LED-lit mirror you'd actually want to stand barefoot in. The fridge hums for about twenty seconds and then goes silent. Outside there's no Interstate hum, no train, no early-shift parking-lot announcements. Just the rural quiet that Missouri does so well.",
  },
  {
    num: "03",
    label: "The morning",
    title: "Breakfast that earns the word 'hot'.",
    body:
      "Coffee starts at six. Waffles by six-fifteen — proper batter, real maple, not packets. There's bread for toast, fresh fruit, yogurt, cereal, hot cocoa for whoever's six years old today. It's served by people who know your name by Tuesday. You eat, you fill a travel mug, you go.",
  },
  {
    num: "04",
    label: "The leaving",
    title: "And on the way back, you'll already be planning it.",
    body:
      "Whatever brought you here — a job in Carrollton, family in Brunswick, a long drive to somewhere else — the version of this trip you'll tell your friends about ends with 'we stayed at this little inn on Highway 65'. We'll be here when you come back. Same coffee, same quiet, same warm welcome.",
  },
];

export default function StoryStrip() {
  return (
    <section className="bg-ink text-canvas py-24 md:py-36 relative overflow-hidden" data-testid="story-section">
      <div className="grain" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-8">
            <p className="font-mono-label text-ember mb-4">A night at Westbridge — told in four chapters</p>
            <h2 className="font-display text-5xl md:text-7xl text-canvas leading-[0.98]">
              The story<br />
              <span className="italic text-ember">of one good night.</span>
            </h2>
          </div>
        </div>

        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <article
              key={c.num}
              className={`grid md:grid-cols-12 gap-8 items-start fade-up`}
              style={{ animationDelay: `${i * 80}ms` }}
              data-testid={`story-chapter-${c.num}`}
            >
              <div className="md:col-span-2">
                <p className="font-display text-7xl md:text-8xl text-ember leading-none">{c.num}</p>
                <p className="font-mono-label text-canvas/60 mt-3">{c.label}</p>
              </div>
              <div className="md:col-span-9 md:col-start-4">
                <h3 className="font-display text-3xl md:text-5xl text-canvas leading-tight">{c.title}</h3>
                <p className="mt-6 text-lg leading-relaxed text-canvas/85 max-w-3xl">{c.body}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-20 pt-12 border-t border-canvas/15 flex flex-wrap items-center justify-between gap-6">
          <p className="font-display text-3xl text-canvas/90 max-w-xl">
            Ready to start chapter one?
          </p>
          <div className="flex gap-3">
            <BookButton label="Reserve a Room" testid="story-book-btn" />
            <Link to="/contact" className="btn-ink !text-canvas !border-canvas hover:!bg-canvas hover:!text-ink" data-testid="story-contact-btn">
              Ask a question
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
